import { Box } from '@factorialco/deprecated-design-system'
import { F0Checkbox } from '@factorialco/f0-react'

import { useHover } from 'modules/core/lib/hoverContext'

import { useTreeContext } from 'modules/job_catalog/components/DevJobCatalogTree/context'

interface Props {
  nodeId: string
  checked: boolean
}

const Checkbox = ({ nodeId, checked }: Props) => {
  const { onMultiSelectNode } = useTreeContext()
  const isHover = useHover()

  if (!isHover && !checked) return null

  // Prevent the click event from bubbling up to the parent node
  // This is to prevent the node from being selected when the checkbox is clicked
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
  }

  return (
    <Box onClick={handleClick}>
      <F0Checkbox
        onCheckedChange={(newChecked) => onMultiSelectNode(nodeId, newChecked)}
        checked={checked}
      />
    </Box>
  )
}

export default Checkbox
